module.exports = __webpack_public_path__ + "img/user-act.8b5784a7.png";